"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var constants_1 = require("./constants");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps'], function (_a, carmiProps) {
    var compData = _a.compData, compProps = _a.compProps;
    var pageTopLabel = compData.pageTopLabel, hiddenAnchorIds = compData.hiddenAnchorIds;
    var autoColor = compProps.autoColor, itemsAlignment = compProps.itemsAlignment, orientation = compProps.orientation;
    var requestedPageId = carmiProps.requestedPageId, pageAnchors = carmiProps.pageAnchors, shouldSort = carmiProps.shouldSort;
    var pageHiddenAnchorIds = hiddenAnchorIds && hiddenAnchorIds.hasOwnProperty(requestedPageId)
        ? hiddenAnchorIds[requestedPageId]
        : [];
    var topAnchor = {
        compId: constants_1.PAGE_ANCHORS.TOP_ANCHOR_COMP_ID,
        dataId: constants_1.PAGE_ANCHORS.TOP_ANCHOR_ID,
        name: pageTopLabel || '',
    };
    var reducedAnchors = function () {
        var res = Object.values(pageAnchors);
        if (shouldSort) {
            res.sort(function (a, b) { return a.top - b.top; });
        }
        return res.map(function (item) {
            var dataId = item.dataId, compId = item.compId, name = item.name;
            return { dataId: dataId, compId: compId, name: name };
        });
    };
    var anchors = [topAnchor]
        .concat(reducedAnchors())
        .filter(function (anchorItem) {
        return !pageHiddenAnchorIds.includes(anchorItem.compId);
    });
    return {
        pageTopLabel: pageTopLabel,
        anchors: anchors.length ? anchors : [topAnchor],
        autoColor: autoColor,
        itemsAlignment: itemsAlignment,
        orientation: orientation,
        activeAnchor: {
            compId: constants_1.PAGE_ANCHORS.TOP_ANCHOR_COMP_ID,
            dataId: constants_1.PAGE_ANCHORS.TOP_ANCHOR_ID,
        },
    };
});
exports.css = withCompInfo_1.withCompInfo(['compProps'], function (_a) {
    var compProps = _a.compProps;
    var itemsAlignment = compProps.itemsAlignment, orientation = compProps.orientation;
    var itemsAlignmentFlexVals = {
        left: 'flex-start',
        center: 'center',
        right: 'flex-end',
    };
    return {
        '--items-alignment': itemsAlignmentFlexVals[itemsAlignment],
        '--text-alignment': itemsAlignment,
        '--orientation': orientation === 'left' ? 'row' : 'row-reverse',
    };
});
//# sourceMappingURL=VerticalAnchorsMenu.js.map